module.exports = __webpack_public_path__ + "static/media/collectionWhite.a61461b8.svg";